<template>
  <div class="managementClass">
    <div class="search">
      <el-input v-model="searchVal" :placeholder="$t('managementV2.searchClass')"
                @input="changinput">
      </el-input>
      <i @click="search"></i>
    </div>
    <div class="managementClass-table">
      <el-table height="100%" border :data="managementclassList"
                header-row-class-name="customHeader">
        <el-table-column type="index" width="57" :label="$t('managementV2.number')" align="center">
          <template slot-scope="{$index}">
            {{fromateIndex($index)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('managementV2.className')" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="name" @click="viewClass(row)">
              {{row.name || '--'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('managementV2.major')" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.major || '--'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('managementV2.member')" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.peopleNum || '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('managementV2.creationDate')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.createTime || '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" :label="$t('managementV2.teacher')" align="center">
          <template slot-scope="{row}">
            {{row.creatorName || '--'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('managementV2.operation')" align="center" class-name="operate"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-tooltip effect="dark" :content="$t('managementV2.viewClass')" placement="top">
              <i class="icon-detail" @click="viewClass(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <!-- <el-pagination background :total="totalRows" @current-change="handleCurrentChange"
                     @size-change="handleSizeChange" :current-page.sync="params.page"
                     :page-size="params.rows" :page-sizes="[10, 20, 30, 40]"
                     layout="prev, pager, next, sizes">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getMyClassList } from "@/services/managements"
export default {
  name: "managementClass",
  data () {
    return {
      searchVal: "",
      managementclassList: [
      ],
      params: {
        companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
        name: "",
      },
    }
  },
  created () {

  },
  mounted () {
    this.getMyClassList();
  },
  methods: {
    changinput () {
      this.searchVal = this.searchVal.replace(/^\s*/g, '');
    },
    fromateIndex (index) {
      if (index < 9) {
        return '0' + (index + 1)
      } else {
        return index + 1
      }
    },
    // 获取我的班级
    async getMyClassList () {
      const { result, success } = await getMyClassList(this.params);
      if (success) {
        this.managementclassList = result;
      }
    },
    //搜索内容
    search () {
      this.params.name = this.searchVal;
      this.getMyClassList();
    },
    //查看班级
    viewClass (row) {
      this.$router.push({
        name: "myclassdetail",
        query: {
          key: this.$Base64.encode(JSON.stringify({
            calassId: row.id,
            name: row.name,
            major: row.major,
            peopleNum: row.peopleNum,
            creatorName: row.creatorName,
            createTime: row.createTime,
            companyCode: row.companyCode
          }))
        }
      })
    },
    // //切换页码
    // handleCurrentChange(val) {
    //   this.params.page = val;
    // },
    // //切换当前最大条数
    // handleSizeChange(newrows) {
    //   this.params.rows = newrows
    // },
  }
}
</script>
<style lang="less" scoped>
@import "./style.less";
</style>